import { memo } from 'react';
import { Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import MunicipalityList from 'shell/components/shared/municipality-list';
import { FormikErrors, FormikTouched } from 'formik';
import { AccordionGeneralityFormVM } from 'front-office/view-models/certificate/generality-form';

interface IdentityCardProps {
  disabled?: boolean;
  values?: AccordionGeneralityFormVM;
  onChange: (
    key: keyof AccordionGeneralityFormVM,
    value: AccordionGeneralityFormVM[keyof AccordionGeneralityFormVM]
  ) => void;
  isEditMode?: boolean;
  errors?: FormikErrors<AccordionGeneralityFormVM>;
  touched?: FormikTouched<AccordionGeneralityFormVM>;
}

const MunicipalityReleaseComponent = ({
  disabled,
  values,
  onChange,
  isEditMode,
  errors,
  touched,
}: IdentityCardProps): React.ReactElement => {
  return (
    <Grid
      container
      spacing={0}
      columnSpacing={{ xs: 0, md: 1 }}
      rowSpacing={{ xs: 1, md: 0 }}
      xs={12}
      item
    >
      <Grid item xs={12} md={7}>
        <MunicipalityList
          label="Comune *"
          aria-label="Comune"
          value={values?.municipalityDocument || null}
          fromDate={values?.dateReleaseDocument}
          disabled={isEditMode ? false : disabled}
          onChange={(value) => {
            onChange('municipalityDocument', value);
          }}
          error={touched?.municipalityDocument && Boolean(errors?.municipalityDocument)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Provincia"
          id="province"
          inputProps={{
            maxLength: '2',
          }}
          aria-label="Provincia"
          fullWidth
          onChange={(event) => {
            onChange('provinceDocument', event?.target.value);
          }}
          value={values?.municipalityDocument?.province || ''}
          disabled
        />
      </Grid>
    </Grid>
  );
};

MunicipalityReleaseComponent.displayName = 'Municipality Release component';

const MunicipalityRelease = memo(MunicipalityReleaseComponent);

export default MunicipalityRelease;
